// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { AccountTemplate } from './account-template';
import { AdminSubType } from './admin-sub-type';
import { TemplateAdminType } from './template-admin-type';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class Template extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  templateId!: number;
  adminSubTypeId?: number;
  createdBy!: string;
  createdDate!: Date;
  description!: string;
  locationId!: number;
  ts!: string;
  updatedBy!: string;
  updatedDate!: Date;
  accountTemplates!: AccountTemplate[];
  adminSubType!: AdminSubType;
  templateAdminTypes!: TemplateAdminType[];
}

